// Test IDs for the onboarding guides — the /guides list and detail pages, and
// the "Getting started" summary card rendered on the home pages.

export const guidesTestIds = {
  // ── /guides list ──────────────────────────────────────────────────────────
  page: "guides-page",
  heading: "guides-heading",
  progressLabel: "guides-progress-label",
  list: "guides-list",
  loadingSkeleton: "guides-loading-skeleton",
  emptyState: "guides-empty-state",
  detectionErrorMessage: "guides-detection-error-message",
  card: (id: string) => `guides-${id}-card` as const,
  cardLink: (id: string) => `guides-${id}-link` as const,
  cardStatus: (id: string) => `guides-${id}-status` as const,

  // ── /guides/:guideId detail ───────────────────────────────────────────────
  detailPage: "guide-detail-page",
  detailBackLink: "guide-detail-back-link",
  detailTitle: "guide-detail-title",
  detailSummary: "guide-detail-summary",
  detailSteps: "guide-detail-steps",
  detailStep: (index: number) => `guide-detail-step-${index}` as const,
  detailStepLink: (index: number) => `guide-detail-step-${index}-link` as const,
  detailPrimaryButton: "guide-detail-primary-button",
  detailCompleteButton: "guide-detail-complete-button",
  detailUndoButton: "guide-detail-undo-button",
  detailCompleteBadge: "guide-detail-complete-badge",
  detailUnknownStatus: "guide-detail-unknown-status",
  detailSaveErrorMessage: "guide-detail-save-error-message",
  detailNotFound: "guide-detail-not-found",

  // ── Getting started card (home) ───────────────────────────────────────────
  gettingStartedCard: "getting-started-card",
  gettingStartedProgress: "getting-started-progress-label",
  gettingStartedErrorMessage: "getting-started-error-message",
  gettingStartedItem: (id: string) => `getting-started-${id}-item` as const,
  gettingStartedItemButton: (id: string) => `getting-started-${id}-button` as const,
  gettingStartedViewAllLink: "getting-started-view-all-link",
} as const;
